/* eslint-disable no-tabs */
import styled from 'styled-components'

export const StyledSpan = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: .5rem;
  word-break: break-all;
  text-align: center;

  .textWrap {
    text-wrap: auto;
  }
`

export const Tr = styled.tr`
  background-color: var(--c2);
  &:nth-child(even) {
    background-color: var(--c3);
  }
`

export const Th = styled.th`
  padding: 12px 16px;
  background-color: var(--c3);
	border-bottom: 1px solid var(--c6);
  text-align: center;
  font-weight: bold;
`

export const Td = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #d6d9dc;
`
